import { Check, Lock } from "lucide-react";
import { MODELS } from "../lib/models";

export const ModelPicker = ({ prefs, setPrefs, disabled, isPro, kids, onUpgrade }) => {
  const toggle = (key) => {
    const on = prefs.models.includes(key);
    if (!isPro) return setPrefs({ ...prefs, models: [key] });
    if (on && prefs.models.length === 1) return;
    const models = MODELS.map((m) => m.key).filter((k) => (k === key ? !on : prefs.models.includes(k)));
    setPrefs({ ...prefs, models });
  };
  return (
    <div data-testid="model-picker" className="flex flex-wrap items-center gap-2 mb-3">
      {MODELS.map((m) => {
        const on = prefs.models.includes(m.key);
        return (
          <button
            key={m.key}
            data-testid={`pick-model-${m.testid}`}
            aria-pressed={on}
            disabled={disabled}
            onClick={() => toggle(m.key)}
            className={`what-pick ${on ? "is-on" : ""}`}
            style={{ "--c": m.color }}
          >
            <span className="what-pick-box">{on && <Check size={10} strokeWidth={3} />}</span>
            {m.name}
          </button>
        );
      })}
      {isPro ? (
        <label className="ml-auto flex items-center gap-2 text-xs text-slate-500 font-mono">
          combined by
          <select
            data-testid="merger-select"
            value={prefs.merger}
            disabled={disabled || prefs.models.length < 2}
            onChange={(e) => setPrefs({ ...prefs, merger: e.target.value })}
            className="what-select"
          >
            {MODELS.map((m) => <option key={m.key} value={m.key}>{m.name}</option>)}
          </select>
        </label>
      ) : kids ? null : (
        <button data-testid="picker-upgrade-btn" onClick={onUpgrade} className="ml-auto flex items-center gap-1.5 text-xs font-mono text-slate-400 hover:text-[#D4FF3A] transition-colors">
          <Lock size={12} /> Free: 1 AI · <span className="text-[#D4FF3A]">Combine all 3 with Pro</span>
        </button>
      )}
    </div>
  );
};
